module.exports = __webpack_public_path__ + "static/label-numbers-home2.f24bf74d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mb/home/label-numbers-home2.png
// module id = 544
// module chunks = 35783957827783